<template>

  <div class="calendar-box" :style='{height:calHeight + "rem"}'>
    <ul class="calendar-head">
      <li>一</li><li>二</li><li>三</li><li>四</li><li>五</li><li>六</li><li>日</li>
    </ul>
    <transition name="fade">
      <calendarContent ref="calendar_swiper" :dateList="dateList" :formateTime="formateTime" :checkDate="current_day" @on-change="changeIndex" @calendarHeight="calendarHeight">
        <div v-for="(month,index) in monthList" :key="index" class="month swiper-item">
        <ul v-for="(week,weekindex) in month" :key="weekindex" style="max-height: 1.06667rem">
          <li  style="max-height: 1.01333rem" v-for="(day, dayindex) in week"
               :class="{ ischecked: formatDateTime(new Date()) == day.date,ischecked: checkedDay == day.date,istoday: day.istoday}"
               @click.prevent.stop="chooseDay(day.year, day.month,day.day,day.othermonth,day.mode,day.thing)"
               :key="dayindex">
            <div class="week-day" style="max-width: 1.01333rem;max-height: 1.01333rem" :class="{ischecked:checkedDay==day.date,othermonth:day.othermonth,istoday:day.istoday,}">
              <span class="one-day">
  				    	<i class="day" style="max-height: 1.01333rem">{{day.day}}</i>
  				    	<!-- <i>{{day.nongli.old_str}}</i> -->
              </span>
              <div class="thing">
                <div :key="index" v-for="(thing,index) in day.thing">
                 <a style="max-height: 4px;max-width: 4px" v-if="thing.title" :style="{color:thing.color}" ></a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      </calendarContent>
    </transition>
    <div class="splitLine">
      <img :class="arrowFlag?'splitImg':'reverseSplitImg'" src="@/assets/image/home/up.png" />
    </div>
  </div>
</template>
<script>
  import calendarContent from './swiper-monthorweek.vue'
  import format from './format'
  import {formatDateTime} from "@/utils/dateTimeUtil"
  export default{
    data(){
      return{
        disp_date:new Date(),
        today:new Date(),
        current_day:new Date(),
        monthList:[],
        checkedDay:'0000-00-00',
        can_click:true,
        calHeight:'',  //日历外框高度，自适应要用到
        arrowFlag:true,
        dateFlag:false,
      }
    },
    props:{
      dateList:{
        type:Array,
        default: () => {
          return []
        }
      },
      choseDay:{
        type:String,
        default: () => {
          return ''
        }
      },
    },
    components:{
      calendarContent
    },
    computed:{
      //当前选中日期
      formateTime(){
        // 标准时间转xxxx年xx月xx日
        return this.formatDateTime(this.disp_date);

      },
    },
    created(){
      this.todayDate();
      this.get3week();

    },
    methods:{
      calendarHeight(newVal){
        this.calHeight = newVal + 1;
        if(this.calHeight == '2.6'){
          this.arrowFlag = true;
          this.$emit('arrowFlag',this.arrowFlag)
        }else if(this.calHeight == '7.98667'){
          this.arrowFlag = false;
          this.$emit('arrowFlag',this.arrowFlag)
        }
      },
      todayDate(){
        this.checkedDay = this.formatDateTime(this.today);
        this.$emit("getMonth",this.formatDateTime(this.disp_date))
      },
      chooseDay(year,month,day,othermonth,mode){
        // 为了PC端点击事件和移动冲突
        if(!this.can_click)
        return
        // if (new Date().getMonth() == month){
          this.current_day = new Date(year,month,day)
          this.checkedDay = this.format(year,month,day)
          if(othermonth && mode == 'month'){
            var _tmpdt = new Date(this.disp_date.getFullYear(),this.disp_date.getMonth()-othermonth,0)
            var maxday = _tmpdt.getDate()
            var _day = maxday<day?maxday:day
            this.disp_date = new Date(year,month-othermonth,_day)
            this.changeIndex(othermonth,false,true)
          }else if(othermonth && mode == 'week'){
            this.disp_date = this.current_day
          }else{
            this.disp_date = this.current_day
          }
          this.$emit("getMonth",this.formatDateTime(this.disp_date))
        // }
      },
      formatDateTime(date){
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        return y + '-' + m + '-' + d;
      },
      format(year,month,day){
        month++
        month<10&&(month='0'+month)
        day<10&&(day='0'+day)
        return year + '-' + month + '-' + day;
      },
      getWeek(year,month,day){
        //year,month,day为选中当天的年月日
        var dt = new Date(year,month,day)
        var weekArr = []
        var dt_first = new Date(year,month,day-((dt.getDay()+6) % 7))
        var week = []
        //循环选中当天所在那一周的每一天
        for(var j=0;j<7;j++){
          var newdt = new Date(dt_first.getFullYear(),dt_first.getMonth(),dt_first.getDate()+j)
          var _year = newdt.getFullYear()
          var _month = newdt.getMonth()
          var _day = newdt.getDate()
          week.push({
            mode:'week',
            day:_day,
            year:_year,
            month:_month,
            date:this.format(_year,_month,_day),
            //日历要显示的其他内容
            // thing:(day == 22 || day == 4) ? [{title:'预约',color:'red'}]:[],
            thing:this.ifOrder(_year,_month,_day),
            nongli:format.solar2lunar(_year,_month+1,_day),
            istoday:(this.today.getFullYear()==_year && this.today.getMonth()==_month && this.today.getDate() == _day)?true:false,
            ischecked:false,
            othermonth:_month!=month
          })
        }
        weekArr.push(week)
        return weekArr
      },
      getMonth(year,month){  //创建单月历
        var monthArr = []
        var dt_first = new Date(year,month,1)   //每个月第一天
        var dt_last = new Date(year,month+1,0)   //每个月最后一天
        var monthLength = dt_last.getDate()-dt_first.getDate()+1
        var daylist =[];
        var space = (dt_first.getDay() - 1 + 7) % 7   //月历前面空格
        for(var i = -space;i<36;i+=7){
          var week = []
          for(var j=0;j<7;j++){
            var day = i+j+1
            if(day>0 && day<=monthLength){
              week.push({
                mode:'month',
                day:day,
                year:year,
                month:month,
                date:this.format(year,month,day),
                //日历要显示的其他内容
                thing:this.ifOrder(year,month,day),
                nongli:format.solar2lunar(year,month+1,day),
                istoday:(this.today.getFullYear()==year && this.today.getMonth()==month && this.today.getDate() == day)?true:false,
                ischecked:false
              })
            }else{
              //其它月份
              //week.push({})
              var newdt = new Date(year,month,day)
              var _year = newdt.getFullYear()
              var _month = newdt.getMonth()
              var _day = newdt.getDate()
              week.push({
                mode:'month',
                day:_day,
                year:_year,
                month:_month,
                date:this.format(year,month,day),
                thing:this.ifOrder(year,month,day),
                nongli:format.solar2lunar(_year,_month+1,_day),
                istoday:(this.today.getFullYear()==_year && this.today.getMonth()==_month && this.today.getDate() == _day)?true:false,
                ischecked:false,
                othermonth:day<=0?-1:1,
              })
            }
          }
          monthArr.push(week)
        }
        return monthArr
      },
      ifOrder(year,month,day){
        let dateTime = this.format(year,month,day);
        if(this.dateList.indexOf(dateTime) >= 0){
          return [{title:'.'}]
        }else{
          return []
        }
      },
      get3month(){
        var year = this.disp_date.getFullYear()
        var month = this.disp_date.getMonth()
        this.monthList = []
        this.monthList.push(this.getMonth(year,month-1))
        this.monthList.push(this.getMonth(year,month))
        this.monthList.push(this.getMonth(year,month+1))
      },
      get3week(){
        var year = this.disp_date.getFullYear()
        var month = this.disp_date.getMonth()
        var day = this.disp_date.getDate()
        this.monthList = []
        this.monthList.push(this.getWeek(year,month,day-7))
        this.monthList.push(this.getWeek(year,month,day))
        this.monthList.push(this.getWeek(year,month,day+7))
        this.disp_date = new Date(this.monthList[1][0][0].date)
      },
      changeIndex(index,is_week,is_click = false){
        if(index){
          if(is_week){
            this.disp_date = new Date(this.disp_date.getFullYear(),this.disp_date.getMonth(),this.disp_date.getDate()+(7*(index)))
            this.get3week()
          }else{
            // return;
            var _tmpdt = new Date(this.disp_date.getFullYear(),this.disp_date.getMonth()+index,0)
            var maxday = _tmpdt.getDate()
            var _day = maxday<this.disp_date.getDate()?maxday:this.disp_date.getDate()
            this.disp_date = new Date(this.disp_date.getFullYear(),this.disp_date.getMonth()+index,_day)
            this.get3month()
          }
          this.$refs.calendar_swiper.move_change()
        }
      }
    },
    watch:{
      dateList(){
        if(this.calHeight == '2.6'){
          this.get3week();
        }else if(this.calHeight == '7.98667'){
          this.get3month();
        }
      },
      choseDay(newVal,oldVal){
        this.disp_date = new Date(newVal);
        if (this.formatDateTime(new Date()) == newVal){
          this.checkedDay = newVal;
        }
        if(this.calHeight == '2.6'){
          this.get3week();
        }else if(this.calHeight == '7.98667'){
          this.get3month();
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  .calendar-box{
    position: relative;
    color: #fff;
    border-radius: 10px 10px 0 0 ;
    z-index:99;
    transition: all .2s ease;
    overflow: hidden;
    margin: 15px 15px 0;
  }
  .calendar-head{
    /* background: #4188d8; */
    display: flex;
    height:30px;
    line-height: 30px;
  }

  .calendar-head li{
    flex-grow: 1;
    text-align: center;
    color: #999;
    font-size: 12px;
  }
  .splitLine{
    margin-top: -20px;
    display: flex;
    justify-content: center;
    .gray_line{
      height: 1px;
      background: #e5e5e5;
      width: calc(100% - 30px);
      float: left;
      margin: 10px 5px;
    }
    .splitImg{
      position: relative;
      top: 5px;
      left: -1px;
      width: 12px;
      height: 12px;
    }
    .reverseSplitImg{
      position: relative;
      top: 5px;
      left: -1px;
      width: 12px;
      height: 12px;
      transform: rotate(-180deg);
    }
  }
  .calendar-today{
    position: absolute;
    width: 100%;
    height: 0.2rem;
    text-align: center;
    font-size: 15px;
    color: #333;
    z-index: 9;
    bottom:0.2rem;
  }
  .calendar-toggle{
    position: absolute;
    width: 100%;
    height: 0.1rem;
    z-index: 9;
    bottom:0.1rem;
    .toggle-line{
      position: relative;
      left: 50%;
      bottom: 0.01rem;
      transform: translateX(-50%);
      width: 0.3rem;
      height: 0.02rem;
      border-radius: 1px;
    }
  }
  .swiper-item{
    position: absolute;
    width:100%;
    height:100%;
    top:0;
  }
  .swiper-item:nth-child(1){
    left: calc(-100% - 22px);
  }
  .swiper-item:nth-child(2){
    left:0;
  }
  .swiper-item:nth-child(3){
    left: calc(100% + 22px);
  }
  .month ul{
    display:flex;
    margin:0;
    padding:0;
    width: 100%;
    height:1.06667rem;
    min-height:1.06667rem;
  }
  .month li{
    flex: 1;
    flex-grow: 1;
    color: #333;
    overflow: hidden;
  }
  .week-day{
    position: relative;
    width: 1.01333rem;
    height: 1.01333rem;
    margin: auto;
    font-size:12px;
    text-align: center;
    border: 0;
    line-height: 10px;
    overflow: hidden;
    z-index: 1;
  }
  .week-day .one-day{
  }
  .week-day i{
    display:block;
    text-align: center;
    font-size: 10px;
    font-style:normal;
    padding:1px;
    line-height: 1.01333rem;
    height:1.01333rem;
  }
  .week-day.ischecked{
    border-radius: 50px;
    color: #fff !important;
    background: #ffb870;
    opacity: 0.7;
    .thing a{
      color: var(--main-color);
      background: var(--main-color);
    }
  }
  .week-day.istoday{
    border-radius: 50px;
    background-color: var(--main-color);
    color: #fff;
  }
  .thing{
    position: absolute;
    left: 50%;
    bottom: 0.02rem;
    transform: translateX(-50%);
    margin-top: 3px;
  }
  .thing a {
    cursor: pointer;
    display: block;
    width: 4px;
    height: 4px;
    word-break: break-all;
    line-height: 4px;
    color: var(--main-color);
    background: var(--main-color);
  }

  .othermonth{
    color: #999;
    /*display: none;*/
    /*pointer-events: none;*/
  }
  .istoday{
    .today{
      font-size: 16px;
      color: #5054F4;
    }
  }
</style>
